import React from 'react'
import { Flex, Box, Copy, Dropdown, Icon, themeColor, themeMediaQuery, Hide } from '@elparking/components'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'

import FilterButton from '../../ui/FilterButton'

import { SelectorElementRounded, SelectedElementRounded, IconPlaceholder, CustomSelectedElementWrapper } from './SelectOrderBy'
import { PARKING_ORDER_BY_PRICE, PARKING_ORDER_BY_DISTANCE } from 'commons/js/constants'

const SortBarWrapper = styled.div`
    padding: 0.8em 0;
    margin: 0 1em 0 1em; 
    border-bottom: 1px solid ${themeColor('lightGray40')};
    background: ${themeColor('white')};
    ${themeMediaQuery('medium')} {
        padding: 0 0 0.8em 0;
        margin: 1em 1em 0 1em;
    }
`

const ParkingMessage = ({parkingsNumber}) => parkingsNumber === 1
    ? <FormattedMessage
      defaultMessage='1 parking disponible:'
      />
    : <FormattedMessage
      defaultMessage='{parkingsNumber} parkings disponibles:'
      values={{parkingsNumber}}
      />

ParkingMessage.propTypes = {
    parkingsNumber: PropTypes.number,
}

const CustomSelectedElement = ({children}) => {
    return (
        <CustomSelectedElementWrapper>
            {defaultPlaceholderOrderDropdown} {children}
        </CustomSelectedElementWrapper>
    )
}

CustomSelectedElement.propTypes = {
    children: PropTypes.element,
}

const orderByDistanceLabel = <FormattedMessage defaultMessage='más cercano' />
const orderByPriceLabel = <FormattedMessage defaultMessage='menor precio' />
const defaultPlaceholderOrderDropdown = <FormattedMessage defaultMessage='Ordenar por' />

const options = [
    {
        label: orderByDistanceLabel,
        value: PARKING_ORDER_BY_DISTANCE,
    },
    {
        label: orderByPriceLabel,
        value: PARKING_ORDER_BY_PRICE,
    },
]

const SortBar = ({ parkingsNumber, filterNumber, showFilterBox, onShowFilters, onOrderBy, order }) => (
    <SortBarWrapper>
        <Flex flexDirection='row' flexWrap='wrap' justifyContent='space-between' alignItems='center' w='100%'>
            <Hide xs sm md>
                <Copy transform='uppercase' fontWeight='medium' fontSize='small' padding='0 0.5em 0 0'>
                    {parkingsNumber > 0
                        ? <ParkingMessage parkingsNumber={parkingsNumber} />
                        : <FormattedMessage defaultMessage='0 parking disponibles:' />}
                </Copy>
            </Hide>
            <Hide lg>
                {showFilterBox && <FilterButton filterNumber={filterNumber} onShowFilters={onShowFilters} />}
            </Hide>
            <Box mt={['0.2em', '0']}>
                <Dropdown
                  onlyDesktop
                  defaultValue={order}
                  value={order}
                  options={options}
                  placeholder={defaultPlaceholderOrderDropdown}
                  selectorElement={SelectorElementRounded}
                  selectedElement={SelectedElementRounded}
                  selectedContentElement={CustomSelectedElement}
                  iconPlaceholderElement={() => <IconPlaceholder><Icon type='arrow-down' size='xxSmall' color='inherit' /></IconPlaceholder>}
                  renderPlaceholder={() => defaultPlaceholderOrderDropdown}
                  renderOption={(option) => (
                      <Flex>
                          <Copy color='black' padding='0.2em 0' size='small' fontWeight='regular' fontSize='small'>
                              {option.label}
                          </Copy>
                      </Flex>
                    )}
                  renderSelected={(selected) => (selected.label)}
                  onChange={(option) => { onOrderBy(option.value) }}
                />
            </Box>
        </Flex>
    </SortBarWrapper>
)

SortBar.propTypes = {
    onShowFilters: PropTypes.func,
    filterNumber: PropTypes.number,
    parkingsNumber: PropTypes.number,
    onOrderBy: PropTypes.func,
    order: PropTypes.string,
    showFilterBox: PropTypes.bool,
}

SortBar.defaultProps = {
    filterNumber: 0,
    parkingsNumber: 0,
    showFilterBox: true,
    onOrderBy: () => {},
}

export default SortBar
